export const UNDEFINED = 0;
export const PENDING_REPL = 12;
export const PENDING_REG = 14;